import { Component, OnInit, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';

import { AuthenticationService } from '../authentication.service';

import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { MenutitleService } from '../../../shared/menutitle.service';
import { ShowmenuService } from '../../../shared/showmenu.service';
//import { MenucontentService } from '../../../shared/menucontent.service';

import { BeepService } from '../../../shared/beep.service';
import { VibrateService } from '../../../shared/vibrate.service';

import { ConnectionService } from 'ng-connection-service';

//import { NgxIndexedDBService } from 'ngx-indexed-db';

export interface DialogData {
  dialogtext: string;
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  loginForm: UntypedFormGroup;
  loading = false;
  submitted = false;
  error = '';
  showmenu: boolean;

  isConnected = true;
  noInternetConnection: boolean;

  onSubmit() {
    this.submitted = true;

    if (!this.loginForm.valid) {
      return;
    }

    if (this.noInternetConnection) {
      this.openDialog(
        'No Internet connection. You need to be online when logging in'
      );
      return;
    }

    this.loading = true;

    this.authenticationService
      .login(this.loginForm.controls.pin.value)
      .pipe(first())
      .subscribe({
        next: (response) => {
          if (response.error == 'None' && response.logged_in) {
            //this.BeepService.beep();

            localStorage.setItem('currentUser', JSON.stringify(response));
            localStorage.setItem(
              'global_menu_json',
              JSON.stringify(response.events)
            );
            localStorage.setItem('global_client_id', response.client_id);

            if (!localStorage.getItem('global_device_id')) {
              localStorage.setItem('global_device_id', this.randomString(6));
            }

            localStorage.setItem(
              'global_user_name',
              this.loginForm.controls.timekeeper_name.value
            );
            localStorage.setItem(
              'global_client_pin',
              this.loginForm.controls.pin.value
            );

            localStorage.setItem('global_logged_in', 'Yes');

            this.router.navigate(['/participantkeyboard']);
          } else {
            this.openDialog(response.error);
            this.loading = false;
          }

          //https://blog.angular-university.io/angular-material-dialog/
        },
        error: (error) => {
          this.error = error;
          this.loading = false;
          this.openDialog(error.message);
        },
      });
  }

  goBeep(){
    this.BeepService.beep();
    this.goBr();
  }

  goBr(){
    this.VibrateService.vibrate();
  }

  randomString(length) {
    var text = '';
    var possible = 'abcdefghijklmnpqrstuvwxyz123456789';

    for (var i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return text;
  }

  constructor(
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    public dialog: MatDialog,
    private ShowmenuService: ShowmenuService,
    //private MenucontentService: MenucontentService,
    private menutitle: MenutitleService,
    private BeepService: BeepService,
    private VibrateService: VibrateService,
    private connectionService: ConnectionService
  ) {
    this.connectionService.monitor().subscribe((isConnected) => {
      this.isConnected = isConnected;
      if (this.isConnected) {
        this.noInternetConnection = false;
      } else {
        this.noInternetConnection = true;
      }
    });
  }

  ngOnInit(): void {
    // Auto log in when returned after 4 hours (and not logged out when left)
    var is_logged_in = localStorage.getItem('global_logged_in');
    var current_route = decodeURI(localStorage.getItem('global_current_route'));

    var time_now = Math.floor(Date.now() / 1000);
    var last_time = parseInt(localStorage.getItem('global_time_now'));
    var time_diff = time_now - last_time;

    // Auto login
    if (is_logged_in == 'Yes' && current_route != '' && time_diff < 4 * 3600) {
      this.router.navigate([current_route]);
    }

    this.loginForm = this.formBuilder.group({
      timekeeper_name: ['', [Validators.required]],
      pin: ['', [Validators.required]],
    });

    this.ShowmenuService.changeShowmenu(false);
    this.menutitle.showMenupink(false);
  }

  openDialog(dialog_text) {
    this.dialog.open(DialogElementsExampleDialog, {
      height: '180px',
      width: '350px',
      data: {
        dialogtext: dialog_text,
      },
    });
  }

  // https://www.positronx.io/angular-8-reactive-forms-validation-with-angular-material-8/
  // https://medium.com/@vivek0208/create-form-using-angular-material-f2472dab1687
}

@Component({
  selector: 'dialog-elements',
  templateUrl: 'login.dialog.html',
})
export class DialogElementsExampleDialog {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialog: MatDialog
  ) {}
}
